import { render, staticRenderFns } from "./CreateMetalPlace.vue?vue&type=template&id=bffc9836&scoped=true&"
import script from "./CreateMetalPlace.vue?vue&type=script&lang=js&"
export * from "./CreateMetalPlace.vue?vue&type=script&lang=js&"
import style0 from "./CreateMetalPlace.vue?vue&type=style&index=0&id=bffc9836&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffc9836",
  null
  
)

export default component.exports